import React from "react";
import { Box } from "@mui/system";

const IndicatorSeparator = ({ isFocused }) => {
  return (
    <Box
      component="span"
      sx={{
        alignSelf: "stretch",
        width: 1,
        marginTop: 0.25,
        marginBottom: 0.25,
        background: isFocused ? "grey.700" : "grey.400",
        transition: "background 0.2s",
      }}
    />
  );
};

export default IndicatorSeparator;
